if (typeof jQuery != "undefined") {
    (function($) {
        "use strict";

        ZZ.Newsletter = function(form) {
            var base = this;
            base.form = form;
            base.submitBtn = base.form.find("[type=submit]");
            base.hiddenInput = base.form.find("[type=hidden]");

            base.submitHandler = new ZZ.SubmitHandler(base.form);
            base.messageHandler = new ZZ.MessageHandler(base.form);

            base.assignListeners();
        };

        ZZ.Newsletter.prototype = {
            assignListeners: function() {
                var base = this;
                base.submitHandler.onBeforeSubmit = function() {
                    base.messageHandler.hideMessage();
                };

                base.submitHandler.handleSubmitResponse = function(data) {
                    if (
                        typeof data.validation === "string" &&
                        data.validation.toUpperCase() === "OK"
                    ) {
                        if (base.hiddenInput.val() === "true") {
                            base.hiddenInput.val("false");
                            base.submitBtn.html("Afmelden");
                        } else {
                            base.hiddenInput.val("true");
                            base.submitBtn.html("Aanmelden");
                        }
                    }
                    if (typeof data.message !== "undefined") {
                        base.messageHandler.showMessage(data.message);
                    }
                };

                base.submitHandler.handleError = function() {
                    base.messageHandler.showMessage(
                        "Aanmelden is niet gelukt, probeert u het later nog eens."
                    );
                };
            }
        };
    })(jQuery);
}
